enum OrderItemTypeEnum {
    Standard = 1,
    Nuts,
}

export default OrderItemTypeEnum;
